const AllClaims = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83203 25.8275L37.7122 22.0859L40.79 45.5842L11.6989 48.9981L5.83203 25.8275Z"
        fill="#4F9493"
      />
      <path
        d="M26.3601 26.0589C26.3601 26.0589 28.7627 25.8664 28.0228 20.6154L23.9363 17.9257L23.6521 18.0159C23.6521 18.0159 23.127 19.96 24.2709 23.0598C25.4149 26.1596 26.3601 26.0589 26.3601 26.0589Z"
        fill="#FFBF9F"
      />
      <path
        d="M15.4117 38.1976L18.7981 40.2974L39.5585 34.825L34.0461 14.3587L10.9404 21.2028L15.4117 38.1976Z"
        fill="#F2F0ED"
      />
      <path
        d="M40.5554 35.4042L18.6669 41.1718L14.7164 38.7176L9.95332 20.6468L34.6164 13.3427L40.5554 35.4042ZM18.9309 39.4207L38.5592 34.2307L33.4777 15.3756L11.9258 21.7567L16.1153 37.6781L18.9309 39.4207Z"
        fill="#E3E0DB"
      />
      <path
        d="M19.249 40.7293L18.5586 36.6385L14.779 38.0059L19.249 40.7293Z"
        fill="#E3E0DB"
      />
      <path
        d="M16.5016 23.2701L19.7148 35.7852L21.29 35.3808L18.0767 22.8657L16.5016 23.2701Z"
        fill="#E3E0DB"
      />
      <path
        d="M19.5406 22.4537L22.7539 34.9688L24.329 34.5644L21.1158 22.0493L19.5406 22.4537Z"
        fill="#E3E0DB"
      />
      <path
        d="M28.9174 26.3361C28.9174 26.3361 31.2519 26.9358 32.2607 21.7297L29.2716 17.8569L28.9735 17.8498C28.9735 17.8498 27.8444 19.5173 27.9176 22.8206C27.9908 26.1239 28.9174 26.3361 28.9174 26.3361Z"
        fill="#FFBF9F"
      />
      <path
        d="M14.6191 34.2567L17.1381 37.3438L38.5496 38.9226L39.9959 17.7764L15.9203 16.7318L14.6191 34.2567Z"
        fill="#F2F0ED"
      />
      <path
        d="M39.302 39.7909L16.7278 38.1242L13.7906 34.5184L15.166 15.8812L40.8639 16.9974L39.302 39.7909ZM17.5471 36.5542L37.7962 38.0318L39.1258 18.5493L16.6702 17.5724L15.4517 33.9905L17.5471 36.5542Z"
        fill="#E3E0DB"
      />
      <path
        d="M17.4215 37.8966L18.0997 33.8038L14.0807 33.8673L17.4215 37.8966Z"
        fill="#E3E0DB"
      />
      <path
        d="M20.5021 20.4876L19.4688 33.3672L21.0898 33.4972L22.1231 20.6177L20.5021 20.4876Z"
        fill="#E3E0DB"
      />
      <path
        d="M23.6447 20.7103L22.6113 33.5898L24.2323 33.7199L25.2657 20.8403L23.6447 20.7103Z"
        fill="#E3E0DB"
      />
      <path
        d="M31.6241 28.1225C31.6241 28.1225 33.666 29.403 36.209 24.7495L34.5379 20.1518L34.256 20.0544C34.256 20.0544 32.6737 21.3 31.7398 24.4694C30.8058 27.6388 31.6241 28.1225 31.6241 28.1225Z"
        fill="#FFBF9F"
      />
      <path
        d="M15.5976 31.3234L17.0595 35.0299L36.9792 43.0388L44.7822 23.3316L22.1621 15.0222L15.5976 31.3234Z"
        fill="white"
      />
      <path
        d="M37.4294 44.1006L16.4287 35.6547L14.7259 31.3271L21.6991 13.9886L45.843 22.8591L37.4294 44.1006ZM17.6863 34.4079L36.5293 41.9672L43.7155 23.8096L22.6182 16.0568L16.4689 31.3287L17.6863 34.4079Z"
        fill="#E3E0DB"
      />
      <path
        d="M17.1611 35.6495L19.0508 31.9562L15.2025 30.7958L17.1611 35.6495Z"
        fill="#E3E0DB"
      />
      <path
        d="M25.3802 20.0002L20.4824 31.957L21.9873 32.5734L26.8851 20.6166L25.3802 20.0002Z"
        fill="#E3E0DB"
      />
      <path
        d="M28.3119 21.1623L23.4141 33.1191L24.9189 33.7355L29.8167 21.7787L28.3119 21.1623Z"
        fill="#E3E0DB"
      />
      <path
        d="M38.3607 24.6936L33.4629 36.6504L34.9678 37.2667L39.8656 25.3099L38.3607 24.6936Z"
        fill="#E3E0DB"
      />
      <path
        d="M11.6992 49.0005L16.1084 27.3012L30.1745 26.0684L29.357 30.3617L47.8323 28.0196L40.7902 45.5865L11.6992 49.0005Z"
        fill="#85CFC9"
      />
      <path
        d="M31.8004 7.9141L30.1504 8.69141L31.8866 12.0606L33.5366 11.2833L31.8004 7.9141Z"
        fill="#FBBF24"
      />
      <path
        d="M37.0805 6.99985L35.7617 11.2539L37.5253 11.7537L38.8441 7.49964L37.0805 6.99985Z"
        fill="#FBBF24"
      />
      <path
        d="M42.9414 10.8904L39.1055 12.8438L39.9716 14.3986L43.8075 12.4452L42.9414 10.8904Z"
        fill="#FBBF24"
      />
      <path
        d="M35.7824 37.023L20.8613 38.709L21.0024 39.8505L35.9235 38.1645L35.7824 37.023Z"
        fill="#5BB0AA"
      />
      <path
        d="M28.6917 35.0431L21.3203 35.8848L21.4629 37.0261L28.8343 36.1845L28.6917 35.0431Z"
        fill="#5BB0AA"
      />
      <path
        d="M35.2804 39.8179L20.3594 41.5039L20.5005 42.6454L35.4215 40.9594L35.2804 39.8179Z"
        fill="#5BB0AA"
      />
    </svg>
  );
};

export default AllClaims;
